import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";


export async function renderFormSubmitWidget(context, widget, parent, override = null) {

    const device = widget?.properties?.desktop;
    if (!device) return;

    // <button>
    const button = context.document.createElement("button");
    button.classList.add("widget", "form_submit_widget");
    button.type = "button";
    const breakpoint = context.currentBreakpoint;

    button.textContent = widget.content || "Submit";

    // Styles
    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    applyButtonStyles(styles, device.regular);
    applyBorderStyles(styles, device.regular?.border);

    button.setAttribute("style", cssUtil.toStyleString(styles));
    button.setAttribute("data-widgetId", widget.uid);
    button.setAttribute("data-widgetType", widget.type);
    button.setAttribute("data-widgetParent", widget.parent);

    // Submit logic
    button.addEventListener("click", () => {
        handleFormSubmit(button, widget, context);
    });

    parent.appendChild(button);
    return button;
}

function handleFormSubmit(button, widget, context) {

    // Find closest form step
    const form = button.closest(".form_step_widget");
    if (!form) {
        console.warn("No form_step_widget found");
        return;
    }

    const payload = {};
    const fields = form.querySelectorAll(".form_field_widget");

    fields.forEach((field, index) => {
        const labelEl = field.querySelector("div:not(.input)");
        const inputEl = field.querySelector(".input");

        const key =
            labelEl?.textContent?.trim() ||
            `field_${index + 1}`;

        const value = inputEl?.textContent?.trim() || "";

        payload[key] = value;
    });

    // UI feedback
    button.textContent = "Submitted ✓";
    button.disabled = true;
}

function applyButtonStyles(styles, regular) {
    if (!regular) return;

    // Background
    if (regular.background?.type === "solid") {
        styles["background-color"] = cssUtil.getCssColor(regular.background);
    }

    // Font
    const font = regular.font;
    if (font) {
        if (font.fontSize) styles["font-size"] = `${font.fontSize}px`;
        styles["font-family"] = font.fontFamily ||  'Montserrat, sans-serif';

        if (font.color) {
            styles["color"] = cssUtil.getCssColor(font.color);
        }

        if (font.style?.bold) styles["font-weight"] = "bold";
        if (font.style?.italic) styles["font-style"] = "italic";
        if (font.style?.underline) styles["text-decoration"] = "underline";
    }

    styles.cursor = "pointer";
}


function applyBorderStyles(styles, border) {
    if (!border?.radius) return;

    const r = border.radius;

    if (r.topLeft) styles["border-top-left-radius"] = `${r.topLeft}px`;
    if (r.topRight) styles["border-top-right-radius"] = `${r.topRight}px`;
    if (r.bottomLeft) styles["border-bottom-left-radius"] = `${r.bottomLeft}px`;
    if (r.bottomRight) styles["border-bottom-right-radius"] = `${r.bottomRight}px`;

    styles.border = "none";
}
